var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info flex1"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,class:[
                  'info-a',
                  _vm.value == item.value ? 'info-Select' : '',
                ],on:{"click":function($event){return _vm.SelectTap(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }